import React from 'react';

export const FileIcon = ({ color = '#444444', ...restProps }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M11.6663 1.80969H4.99967C4.55765 1.80969 4.13372 1.98529 3.82116 2.29785C3.5086 2.61041 3.33301 3.03433 3.33301 3.47636V16.8097C3.33301 17.2517 3.5086 17.6756 3.82116 17.9882C4.13372 18.3008 4.55765 18.4764 4.99967 18.4764H14.9997C15.4417 18.4764 15.8656 18.3008 16.1782 17.9882C16.4907 17.6756 16.6663 17.2517 16.6663 16.8097V6.80969L11.6663 1.80969Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 1.80969V6.80969H16.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 10.9764H6.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 14.3097H6.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33366 7.64307H7.50033H6.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
